import React from "react";
import { GiftIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { bonusCards } from "../data/content";
export function BonusSection() {
  return <section className="bg-white px-4 py-16" aria-labelledby="bonus-title" data-id="element-1" data-mp="22fd4d3qi7ots">
      <div className="mx-auto max-w-6xl" data-id="element-2" data-mp="22daj0x0aqjve">
        <SectionHeading id="bonus-title" title="And that's not all." accent="Get 5 premium bonus guides — free" data-id="element-3" data-mp="1ydryi2ce0at3" />
        <ul className="mt-12 flex flex-wrap justify-center gap-6" data-id="element-4" data-mp="1ap8ptlpfdw0h">
          {bonusCards.map((b, i) => <li key={b.title} className="flex w-full flex-col overflow-hidden rounded-2xl bg-peach sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]" data-id="element-5" data-mp="15qxfl9v7xjhq" data-mpi={i}>
              <div className="relative bg-white" data-id="element-6" data-mp="1ep93h44pa36h">
                <img src={b.image} alt={`${b.title} cover`} className="aspect-[4/3] w-full object-cover" data-id="element-7" data-mp="r0gdrpeo8rkb" />
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-brand px-3 py-1 font-heading text-xs font-bold uppercase text-white" data-id="element-8" data-mp="mz4lfc4exs8f">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-9" data-mp="29q0ef02vi693" />
                  Bonus #{i + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-10" data-mp="2jhcxb26p1m2z">
                <h3 className="font-heading text-lg font-bold uppercase leading-tight" data-id="element-11" data-mp="2jjz9xg8fyrs2">{b.title}</h3>
                <p className="mt-2 text-sm text-ink-muted" data-id="element-12" data-mp="2oittike8gkd8">{b.tagline}</p>
                <ul className="mt-auto flex flex-wrap gap-2 pt-5" data-id="element-13" data-mp="1qus55zie95yd">
                  {b.highlights.map(h => <li key={h} className="rounded-full bg-white px-3 py-1 text-xs font-medium text-ink" data-id="element-14" data-mp="1vueg22ar2a40">
                      {h}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}